import Generic from './generic'

class Card extends Generic {
  get name() { return this.translates(this.names) }
}

export default Card
